import { REACT_APP_ENV } from "./constants";

const config = {
  development: {
    API_BASE_URL: "https://api.saflearn.flexisafapps-dev.com",
    UMS_BASE_URL: "http://ums-api.common.flexisaf-dev.com",
  },
  staging: {
    API_BASE_URL: "https://saflearn-api.product.flexisaf-stage.com",
    UMS_BASE_URL: "https://ums-api.component.flexisaf-stage.com",
  },
  production: {
    API_BASE_URL: "https://api.saflearn.com",
    UMS_BASE_URL: "https://ums-api.component.flexisaf.com",
  },
};

const { API_BASE_URL } = config[REACT_APP_ENV];
export default API_BASE_URL;
